export default {
      id: "instagram-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#instagram",
      toString: function () {
        return this.url;
      }
    }